import store from 'store';
import {
    DATASET_SUEZMAX_LONDON,
    DATASET_VLCC_HOUSTON,
    DATASET_AFRAMAX_LONDON,
    DATASET_CLEAN_HOUSTON,
    DATASET_SUEZMAX_HOUSTON,
    DATASET_VLCC_LONDON,
    DATASET_FUEL_OIL_LONDON,
    DATASET_SPECIALISED,
    DATASET_DRY_CARGO,
    DATASET_TANKERS,
    DATASET_PCG,
    DATASET_LPG_MIDSIZE,
    DATASET_LPG_VLGC,
    DATASET_LNG,
} from './Datasets';

/*
 * The order of the zones in each array is used to determine sort order
 */
const suezmaxLoadZones = [
    'WAFR',
    'SAFR',
    'CANARY',
    'BSEA',
    'EMED',
    'CMED',
    'WMED',
    'S.O.M.', // Not present in mappings files
    'BALT',
    'BARENTS', // Not present in mappings files
    'NSEA',
    'ECMEX',
    'CARIBS',
    'USG',
    'NAMERICA',
    'ECSAMERICA',
    'WCSAMERICA',
    'USWC',
    'MEG',
    'RSEA',
    'WCI',
    'ECI',
    'EAST OF SUEZ',
    'OZ',
    'EAFR',
    'PACIFIC',
];

const suezmaxDischargeZones = [
    'CANARY',
    'EAFR',
    'EAST',
    'ECI',
    'ECSAMERICA',
    'MEG',
    'OZ',
    'PACIFIC',
    'RSEA',
    'SAFR',
    'STATES',
    'UKCM',
    'USWC',
    'WAFR',
    'WCSAMERICA',
    'WCI',
];

const vlccHoustonLoadZones = [
    'ALASKA',
    'BSEA',
    'CANARY',
    'CARIBS',
    'EAFR',
    'EAST',
    'EAUS',
    'ECMEX',
    'ECSA',
    'INDIA',
    'LAKES',
    'MED',
    'MEG',
    'NAUS',
    'NZ',
    'PACIFIC',
    'RUSSFE',
    'SAFR',
    'STLAW',
    'UKCONT',
    'USAC',
    'USG',
    'USNH',
    'USWC',
    'WAFR',
    'WAUS',
    'WCCAM',
    'WCSAM',
];

const vlccHoustonDischargeZones = [
    'ALASKA',
    'BSEA',
    'CANARY',
    'CARIBS',
    'CHINA',
    'EAFR',
    'EAUS',
    'ECI',
    'ECMEX',
    'JAPAN',
    'KOREA',
    'LAKES',
    'MED',
    'MEG',
    'NAUS',
    'NZ',
    'PACIFIC',
    'RUSSFE',
    'SAFR',
    'SAMERICA',
    'SEA',
    'STLAW',
    'UKCONT',
    'USAC',
    'USG',
    'USNH',
    'USWC',
    'WAFR',
    'WAUS',
    'WCI',
];

const vlccLondonLoadZones = [
    'ALASKA',
    'BSEA',
    'CANARY',
    'CARIBS',
    'EAFR',
    'EAST',
    'EAUS',
    'ECI',
    'ECMEX',
    'LAKES',
    'MED',
    'MEG',
    'NAUS',
    'NZ',
    'PACIFIC',
    'RSEA',
    'RUSSFE',
    'SAFR',
    'SAMERICA',
    'STLAW',
    'UKCONT',
    'USAC',
    'USG',
    'USNH',
    'USWC',
    'WAFR',
    'WAUS',
    'WCCAM',
    'WCI',
];

const aframaxLondonLoadZones = [
    'MED',
    'BSEA',
    'CONT',
    'BALT',
    'SPATL',
    'WAFR',
    'SAFR',
    'CANARY',
    'ECMEX',
    'CARIBS',
    'USG',
    'USAC',
    'USNH',
    'STLAW',
    'LAKES',
    'NBRAZIL',
    'SBRAZIL',
    'ARG',
    'WCCAM',
    'WCSAM',
    'CHILE',
    'ALASKA',
    'USWC',
    'MEG',
    'RSEA',
    'WCIND',
    'ECIND',
    'SPORE',
    'INDO',
    'THAIGULF',
    'VIETNAM',
    'PHIL',
    'SCHINA',
    'CCHINA',
    'NCHINA',
    'KOREA',
    'JAPAN',
    'RUSSFE',
    'WAUS',
    'NAUS',
    'EAUS',
    'NZ',
    'EAFR',
    'PACIFIC',
];

const fuelOilLondonLoadZones = [
    'MED',
    'CONT',
    'WAFR',
    'ECMEX',
    'CARIBS',
    'USG',
    'USAC',
    'USNH',
    'STLAW',
    'LAKES',
    'NBRAZIL',
    'SBRAZIL',
    'ARG',
    'WCCAM',
    'WCSAM',
    'CHILE',
    'ALASKA',
    'USWC',
    'MEG',
    'RSEA',
    'WCIND',
    'ECIND',
    'SPORE',
    'INDO',
    'THAIGULF',
    'VIETNAM',
    'PHIL',
    'SCHINA',
    'CCHINA',
    'NCHINA',
    'KOREA',
    'JAPAN',
    'RUSSFE',
    'WAUS',
    'NAUS',
    'EAUS',
    'NZ',
    'EAFR',
    'PACIFIC',
];

const vlccLondonDischargeZones = [
    'ALASKA',
    'BSEA',
    'CANARY',
    'CARIBS',
    'CHINA',
    'EAFR',
    'EAUS',
    'ECIND',
    'ECMEX',
    'INDO',
    'JAPAN',
    'KOREA',
    'LAKES',
    'MED',
    'MEG',
    'NAUS',
    'NZ',
    'PACIFIC',
    'PHIL',
    'RSEA',
    'RUSSFE',
    'SAFR',
    'SAMERICA',
    'SPORE',
    'STLAW',
    'THAIGULF',
    'UKCONT',
    'USAC',
    'USG',
    'USNH',
    'USWC',
    'VIETNAM',
    'WAFR',
    'WAUS',
    'WCIND',
];

const cleanHoustonLoadZones = [
    'ALASKA',
    'BALT',
    'BSEA',
    'CANARY',
    'CARIBS',
    'CCHINA',
    'EAFR',
    'ECC',
    'ECIND',
    'ECMEX',
    'ECSA',
    'JAPAN',
    'KOREA',
    'LAKES',
    'MED',
    'MEG',
    'NCHINA',
    'NZ',
    'OZ',
    'PACIFIC',
    'RUSSFE',
    'SAFR',
    'SCHINA',
    'SEA',
    'UKCONT',
    'USAC',
    'USG',
    'USWC',
    'WAFR',
    'WCCAM',
    'WCIND',
    'WCSAM',
];

const cleanHoustonDischargeZones = [
    'ALASKA',
    'BALT',
    'BSEA',
    'CANARY',
    'CARIBS',
    'CCHINA',
    'EAFR',
    'ECC',
    'ECIND',
    'ECMEX',
    'ECSA',
    'JAPAN',
    'KOREA',
    'LAKES',
    'MED',
    'MEG',
    'NCHINA',
    'NZ',
    'OZ',
    'PACIFIC',
    'RUSSFE',
    'SAFR',
    'SCHINA',
    'SEA',
    'UKCONT',
    'USAC',
    'USG',
    'USWC',
    'WAFR',
    'WCCAM',
    'WCIND',
    'WCSAM',
];

const specialisedLoadZones = [
    'ADRIATIC',
    'ANTR',
    'ARA',
    'ARG',
    'ATLANTIC',
    'BALT',
    'BSEA',
    'CARIBS/ECCA',
    'CEU',
    'CMED',
    'DIS',
    'EAF',
    'ECAUS',
    'ECCAN',
    'ECI',
    'ECMEX',
    'ECUK',
    'EMED',
    'EMSIA',
    'FEASIA',
    'FRATL',
    'GBS',
    'GNS',
    'ICELAND',
    'LAKES',
    'MCHINA',
    'MEG',
    'NAUS',
    'NBRAZIL',
    'NCHINA',
    'NZ',
    'PACIFIC',
    'RED SEA',
    'RPLATE',
    'RUSSFE',
    'SAF',
    'SBRAZIL',
    'SCHINA',
    'SEASIA',
    'SPATL',
    'STRAITS',
    'USEC',
    'USG',
    'USWC',
    'WAF',
    'WAUS',
    'WCCA',
    'WCCAN',
    'WCI',
    'WCMEX',
    'WCNORWAY',
    'WCSAM',
    'WCUK',
    'WMED',
    'WMSIA',
    'WSEA',
];

const specialisedDischargeZones = [
    'ADRIATIC',
    'ANTR',
    'ARA',
    'ARG',
    'ATLANTIC',
    'BALT',
    'BSEA',
    'CARIBS/ECCA',
    'CEU',
    'CMED',
    'DIS',
    'EAF',
    'ECAUS',
    'ECCAN',
    'ECI',
    'ECMEX',
    'ECUK',
    'EMED',
    'EMSIA',
    'FEASIA',
    'FRATL',
    'GBS',
    'GNS',
    'ICELAND',
    'LAKES',
    'MCHINA',
    'MEG',
    'NAUS',
    'NBRAZIL',
    'NCHINA',
    'NZ',
    'PACIFIC',
    'RED SEA',
    'RPLATE',
    'RUSSFE',
    'SAF',
    'SBRAZIL',
    'SCHINA',
    'SEASIA',
    'SPATL',
    'STRAITS',
    'USEC',
    'USG',
    'USWC',
    'WAF',
    'WAUS',
    'WCCA',
    'WCCAN',
    'WCI',
    'WCMEX',
    'WCNORWAY',
    'WCSAM',
    'WCUK',
    'WMED',
    'WMSIA',
    'WSEA',
];

const dryCargoZones = [
    'BALT',
    'BENGAL',
    'BSEA',
    'CANARY',
    'CARIBS',
    'CCHINA',
    'EAFR',
    'EAUS',
    'EMED',
    'LAKES',
    'MEG',
    'NASIA',
    'NBRAZ',
    'NCHINA',
    'NCSA',
    'PLATE',
    'RSEA',
    'SAFR',
    'SBRAZ',
    'SCHINA',
    'SEASIA',
    'UKCONT',
    'USEC',
    'USG',
    'WAFR',
    'WAUS',
    'WCCA',
    'WCIND',
    'WCNA',
    'WCSAM',
    'WMED',
];

const tankerZones = [
    'ALASKA',
    'ARG',
    'BALT',
    'BSEA',
    'CANARY',
    'CARIBS',
    'CCHINA',
    'CHILE',
    'CMED',
    'EAFR',
    'EAUS',
    'ECIND',
    'ECMEX',
    'EMED',
    'FRATL',
    'INDO',
    'JAPAN',
    'KOREA',
    'LAKES',
    'MEG',
    'MYANMAR',
    'NAUS',
    'NBRAZIL',
    'NCHINA',
    'NOR',
    'NZ',
    'PACIFIC',
    'PHIL',
    'RSEA',
    'RUSARC',
    'RUSSFE',
    'SAFR',
    'SBRAZIL',
    'SCHINA',
    'SPATL',
    'SPORE',
    'STLAW',
    'THAIGULF',
    'TWN',
    'UKATL',
    'UKCONT',
    'USAC',
    'USEC',
    'USG',
    'USWC',
    'VIETNAM',
    'WAUS',
    'WCCAM',
    'WCIND',
    'WCSAM',
    'WMED',
    'WAFR',
];

const globalZones = [
    'ALASKA',
    'ARG',
    'BALT',
    'BSEA',
    'CANARY',
    'CARIBS',
    'CCHINA',
    'CHILE',
    'CMED',
    'EAFR',
    'EAUS',
    'ECIND',
    'ECMEX',
    'EMED',
    'FRATL',
    'INDO',
    'JAPAN',
    'KOREA',
    'LAKES',
    'MEG',
    'MYANMAR',
    'NAUS',
    'NBRAZIL',
    'NCHINA',
    'NOR',
    'NZ',
    'PACIFIC',
    'PHIL',
    'RSEA',
    'RUSARC',
    'RUSSFE',
    'SAFR',
    'SBRAZIL',
    'SCHINA',
    'SPATL',
    'SPORE',
    'STLAW',
    'THAIGULF',
    'TWN',
    'UKATL',
    'UKCONT',
    'USAC',
    'USG',
    'USNH',
    'USWC',
    'VIETNAM',
    'WAUS',
    'WCCAM',
    'WCIND',
    'WCSAM',
    'WMED',
    'WW',
    'WAFR',
];

const gasZones = [
    'ADRIATIC',
    'AG',
    'ARA',
    'ARG',
    'ATLANTIC',
    'BALT',
    'BSEA',
    'CARIBS',
    'CCHINA',
    'CEU',
    'CHILE',
    'CMED',
    'DIS',
    'EAFR',
    'EAUS',
    'ECI',
    'ECMEX',
    'ECUK',
    'EMED',
    'FRATL',
    'GNS',
    'ICELAND',
    'INDO',
    'JAPAN',
    'KOREA',
    'LAKES',
    'NAUS',
    'NBRAZIL',
    'NCHINA',
    'NZ',
    'PACIFIC',
    'PHIL',
    'RSEA',
    'RUSSFE',
    'SAFR',
    'SBRAZIL',
    'SCHINA',
    'SPATL',
    'SPORE',
    'STLAW',
    'THAIGULF',
    'USEC',
    'USG',
    'USWC',
    'VIETNAM',
    'WAFR',
    'WAUS',
    'WCCAM',
    'WCCAN',
    'WCI',
    'WCNORWAY',
    'WCSAM',
    'WCUK',
    'WMED',
    'WSEA',
];

const lngZones = [
    'ARA',
    'BALT S',
    'BAR S',
    'BL SEA',
    'CANARY',
    'CARIBS',
    'C CHIN',
    'C MED',
    'E AF',
    'E AUS',
    'ECI',
    'EC NAM',
    'E MED',
    'FE Asia',
    'N/A',
    'MEG',
    'N BRA',
    'N CHIN',
    'NC SAM',
    'NE ASIA',
    'NOR',
    'PANAM',
    'PLATE',
    'R SEA',
    'S BRA',
    'S CHIN',
    'SE AF',
    'SE AS',
    'S WAF',
    'SUEZ',
    'TURK S',
    'UK ATL',
    'USG',
    'WAF',
    'W AUS',
    'WC CAM',
    'WCI',
    'WC NAM',
    'WC SAM',
    'WE',
    'WM ASIA',
    'W PAC',
    'W SEA',
];

export const loadZones = (datasetId, groupId) => {
    /*
     * I hate myself for adding hardcoded group based logic here but this was bussines request.
     * They wanted this feature as fast as possible and they also told us that fort is slowly
     * going to be in maintenance mode so it is not worth investing time in full scale feature
     *
     * KQP 12th March 2026
     */

    if (groupId) {
        const mappingConfigId =
            store.getState().user.uiSettings.zoneMappingConfig?.id;
        if (mappingConfigId) {
            const mapping = getLoadZoneGroupOrder(groupId);
            if (mapping) {
                return mapping;
            }
        }
    }

    switch (datasetId) {
        case DATASET_SUEZMAX_LONDON:
        case DATASET_SUEZMAX_HOUSTON:
            return suezmaxLoadZones;
        case DATASET_VLCC_LONDON:
            return vlccLondonLoadZones;
        case DATASET_VLCC_HOUSTON:
            return vlccHoustonLoadZones;
        case DATASET_AFRAMAX_LONDON:
            return aframaxLondonLoadZones;
        case DATASET_FUEL_OIL_LONDON:
            return fuelOilLondonLoadZones;
        case DATASET_CLEAN_HOUSTON:
            return cleanHoustonLoadZones;
        case DATASET_SPECIALISED:
            return specialisedLoadZones;
        case DATASET_DRY_CARGO:
            return dryCargoZones;
        case DATASET_TANKERS:
            return tankerZones;
        case DATASET_PCG:
        case DATASET_LPG_MIDSIZE:
        case DATASET_LPG_VLGC:
            return gasZones;
        case DATASET_LNG:
            return lngZones;
        default:
            return globalZones;
    }
};

export const dischargeZones = (datasetId, groupId) => {
    if (groupId) {
        const mappingConfigId =
            store.getState().user.uiSettings.zoneMappingConfig?.id;
        // eslint-disable-next-line default-case
        if (mappingConfigId) {
            const mapping = getDischargeZoneGroupOrder(groupId);
            if (mapping) {
                return mapping;
            }
        }
    }

    switch (datasetId) {
        case DATASET_SUEZMAX_LONDON:
        case DATASET_SUEZMAX_HOUSTON:
            return suezmaxDischargeZones;
        case DATASET_VLCC_LONDON:
            return vlccLondonDischargeZones;
        case DATASET_VLCC_HOUSTON:
            return vlccHoustonDischargeZones;
        case DATASET_CLEAN_HOUSTON:
            return cleanHoustonDischargeZones;
        case DATASET_SPECIALISED:
            return specialisedDischargeZones;
        case DATASET_DRY_CARGO:
            return dryCargoZones;
        case DATASET_TANKERS:
            return tankerZones;
        case DATASET_PCG:
        case DATASET_LPG_MIDSIZE:
        case DATASET_LPG_VLGC:
            return gasZones;
        case DATASET_LNG:
            return lngZones;
        default:
            return globalZones;
    }
};

export const getAvailableZone = (parts) => {
    if (parts && parts.length > 0 && parts[0].deskZone) {
        return parts[0].deskZone;
    } else {
        return null;
    }
};

export const getAvailableArea = (parts) => {
    if (parts && parts.length > 0 && parts[0].deskArea) {
        return parts[0].deskArea;
    } else {
        return null;
    }
};

export const getEastWest = (parts) => {
    if (parts && parts.length > 0 && parts[0].eastWest) {
        return parts[0].eastWest;
    } else {
        return null;
    }
};

export const getAvailableAreaGeared = (parts) => {
    if (parts && parts.length > 0 && parts[0].deskAreaGeared) {
        return parts[0].deskAreaGeared;
    } else {
        return null;
    }
};

export const hasFirstZoneChanged = (currentZone, newLocationParts) => {
    if (currentZone && !newLocationParts) {
        return true;
    }

    if (newLocationParts?.[0]?.haveLocationsBeenLoaded === false) {
        return false;
    }

    const newZone = getAvailableZone(newLocationParts);
    const zonesAreDifferent = currentZone !== newZone;
    return zonesAreDifferent;
};

const getLoadZoneGroupOrder = (groupId) => {
    switch (groupId) {
        case '5dda4d75-b2f3-44e9-9dfb-21033fed6846': // dev
        case 'cffc167a-5231-49ce-958a-d77710f79bee': // staging
        case '9c65c14d-aca4-4002-b286-12f990888766': // prod
            return aframaxLondonLoadZones;
        case '47972c86-74c3-4816-bf1c-c462e899ab7e': // dev
        case 'a9a84203-d3df-41bb-836d-e948af7247d0': // staging
        case '09c08da9-ae1a-4ef5-bfda-ba9d8ecef087': // staging
        case 'fd0518bd-b71b-417a-9e37-4edfc390570b': // prod
        case '780cac5e-dbae-4fc0-b56b-e64900fa91e2': // prod
            return suezmaxLoadZones;
        case 'f6c85add-3127-4e06-9cc0-e03d3332862e': //prod
        case 'c35f6a7f-27a3-4a98-8a2f-a448e08b5715': //staging
            return fuelOilLondonLoadZones;
        default:
            return null;
    }
};

const getDischargeZoneGroupOrder = (groupId) => {
    switch (groupId) {
        case '47972c86-74c3-4816-bf1c-c462e899ab7e': // dev
        case 'a9a84203-d3df-41bb-836d-e948af7247d0': // staging
        case '09c08da9-ae1a-4ef5-bfda-ba9d8ecef087': // staging
        case 'fd0518bd-b71b-417a-9e37-4edfc390570b': // prod
        case '780cac5e-dbae-4fc0-b56b-e64900fa91e2': // prod
            return suezmaxDischargeZones;

        default:
            return null;
    }
};

export const specialOrderGroups = [
    '5dda4d75-b2f3-44e9-9dfb-21033fed6846', // dev
    '47972c86-74c3-4816-bf1c-c462e899ab7e', // dev
    'a9a84203-d3df-41bb-836d-e948af7247d0', // staging
    'cffc167a-5231-49ce-958a-d77710f79bee', // staging
    'c35f6a7f-27a3-4a98-8a2f-a448e08b5715', // staging
    '09c08da9-ae1a-4ef5-bfda-ba9d8ecef087', // staging
    'fd0518bd-b71b-417a-9e37-4edfc390570b', // prod
    '780cac5e-dbae-4fc0-b56b-e64900fa91e2', // prod
    '9c65c14d-aca4-4002-b286-12f990888766', // prod
    'f6c85add-3127-4e06-9cc0-e03d3332862e', //prod
];
